//const XMLParser = require('react-xml-parser');
import TimeUtils from '../helper/TimeUtils';
import StringUtils from '../helper/StringUtils';
import ZeroTimeUtils from '../helper/ZeroTimeUtils';
import WaveformView from '../components/drogable/WaveformView';

class DataObj {
  static projectSubType = 0;

  constructor(dataObj) {
    if (dataObj !== null && dataObj !== undefined) {
      // this.In = dataObj.In;
      // this.Out = dataObj.Out;
      this.tSubType = dataObj.tSubType;

      if (dataObj.In !== null) {
        this.setInOut('In', dataObj.In);
      }
      if (dataObj.Out !== null) {
        this.setInOut('Out', dataObj.Out);
      }

      if (dataObj.InTimecode !== null) {
        // this.InTimecode = StringUtils.checkTimeString(dataObj.InTimecode);
        this.InTimecode = dataObj.InTimecode;
      } else {
        this.InTimecode = TimeUtils.getTimecodeFromTimestring(this.In);
      }

      if (dataObj.OutTimecode !== null) {
        // this.OutTimecode = StringUtils.checkTimeString(dataObj.OutTimecode);
        this.OutTimecode = dataObj.OutTimecode;
      } else {
        this.OutTimecode = TimeUtils.getTimecodeFromTimestring(this.Out);
      }

      if (this.ShotChangeArray === undefined || this.ShotChangeArray === null) {
        this.ShotChangeArray = new Array();
      }

      this.start = dataObj.start;
      this.end = dataObj.end;

      if (dataObj.ShotChange !== undefined || dataObj.ShotChange !== null) {
        this.ShotChange = dataObj.ShotChange;
      }

      if (
        dataObj.isInShotChangeActive !== undefined ||
        dataObj.isInShotChangeActive !== null
      ) {
        this.isInShotChangeActive = dataObj.isInShotChangeActive;
      } else {
        this.isInShotChangeActive = false;
      }

      if (
        dataObj.isOutShotChangeActive !== undefined ||
        dataObj.isOutShotChangeActive !== null
      ) {
        this.isOutShotChangeActive = dataObj.isOutShotChangeActive;
      } else {
        this.isOutShotChangeActive = false;
      }

      if (
        dataObj.isIgnoreShotchange !== undefined ||
        dataObj.isIgnoreShotchange !== null
      ) {
        this.isIgnoreShotchange = dataObj.isIgnoreShotchange;
      } else {
        this.isIgnoreShotchange = false;
      }

      if (this.Memo !== null) {
        this.Memo = dataObj.Memo;
      } else {
        this.Memo = '';
      }

      // if (dataObj.isIgnored !== null || dataObj.isIgnored !== undefined) {
      //   this.isIgnored = dataObj.isIgnored;
      // } else {
      //   this.isIgnored = false;
      // }

      this.Source = dataObj.Source;
      //格式檢察
      this.setSubtitleCaption(dataObj.SubtitleCaption);
      // this.Length = dataObj.Length;
      this.Position = dataObj.Position;

      //更新 Duration  Length
      // this.setDuration();
      this.setLength();
      this.setCPSTitle();
    } else {
      this.init();
    }
  }

  init() {
    this.tSubType = 0; // 設定字幕判定要不要做秒數驗算
    this.In = '';
    this.Out = '';
    this.InTimecode = '';
    this.OutTimecode = '';
    this.start = 0.0;
    this.end = 0.0;
    this.ShotChange = '';
    this.Duration = '';
    this.DurationTitle = '';
    this.CPS = 0.0;
    this.Memo = '';
    this.Source = '';
    this.SubtitleCaption = '';
    this.Length = '';
    this.LengthTitle = '';
    this.Position = '';

    this.ShotChangeSecond = ''; //shot change 資料
    this.ShotChangeArray = []; //shot Array 資料
    this.ShotChangeTitle = ''; //shot change 資料
    this.isIgnoreShotchange = false; // is ignore Shotchange
    this.isInShotChangeActive = false; //  是否修改過In
    this.isOutShotChangeActive = false; //  是否修改過Out

    // this.isIgnored =false; // 是否略過
  }

  /**
   *  設定字幕判定要不要做秒數驗算
   * @param {*} type
   */
  setTSubType(type) {
    this.tSubType = type;
    DataObj.projectSubType = type;
  }

  /**
   * 設定是否要被掠過
   * @param {*} result
   */
  setIsIgnoreShotchange(result) {
    if (result === true) {
      /**
       * 用戶要忽略
       */

      if (
        this.isInShotChangeActive === true &&
        this.isOutShotChangeActive === true
      ) {
        //  可以忽略
        this.isIgnoreShotchange = result;
        this.ShotChange = this.ShotChangeToIgnore(0);
        this.ShotChange = this.ShotChangeToIgnore(1);
        this.ShotChange = this.ShotChangeToIgnore(2);
        return;
      } else if (this.isInShotChangeActive === true) {
        // 忽略
        this.isIgnoreShotchange = result;
        this.ShotChange = this.ShotChangeToIgnore(1);
        return;
      } else if (this.isOutShotChangeActive === true) {
        // 忽略
        this.isIgnoreShotchange = result;
        this.ShotChange = this.ShotChangeToIgnore(2);
        return;
      }

      // 一般忽略
      this.isIgnoreShotchange = result;
      this.ShotChange = this.ShotChangeToIgnore(0);
    } else {
      /**
       * 用戶 不忽略
       */
      this.isIgnoreShotchange = result;
    }
  }

  /**
   * 掠過訊息
   * type 0:全部忽略 1:用戶已經change IN 2:用戶已經change Out
   */
  ShotChangeToIgnore(type) {
    if (type === 1) {
      return '<span style="color: blue;">Changed(in)</span>\n<span style="color: red;">Ignore(in)</span>';
    } else if (type === 2) {
      return '<span style="color: blue;">Changed(out)</span>\n<span style="color: red;">Ignore(out)</span>';
    }
    return '<span style="color: red;">Ignore</span>';
  }

  setShotChangeIn(result) {
    this.isIgnoreShotchange = result;
  }

  /**
   * 確認有沒有修改過In
   * @param {*} result
   */
  setIsInShotChangeActive(result) {
    this.isInShotChangeActive = result;
  }

  /**
   * 確認有沒有修改過Out
   * @param {*} result
   */
  setIsOutShotChangeActive(result) {
    this.isOutShotChangeActive = result;
  }

  /**
   * 要顯示的內容
   * @param {*} shotdata 內容字串
   */
  setShotChange(shotdata) {
    if (
      this.isInShotChangeActive === true &&
      this.isOutShotChangeActive === true
    ) {
      this.ShotChange = '<span style="color: blue;">Changed(In,Out)</span>';
      return;
    } else if (this.isInShotChangeActive === true) {
      this.ShotChange =
        '<span style="color: blue;">Changed(In)</span>\n' + shotdata;
      return;
    } else if (this.isOutShotChangeActive === true) {
      this.ShotChange =
        shotdata + '\n<span style="color: blue;">Changed(Out)</span>';
      return;
    } else if (this.isIgnoreShotchange === true) {
      this.ShotChange = this.ShotChangeToIgnore(0);
      return;
    }

    this.ShotChange = shotdata;
  }

  //更新字幕
  setSubtitleCaption(SubtitleCaption) {
    this.SubtitleCaption = StringUtils.checkHTMLmark(SubtitleCaption);
    // this.SubtitleCaption = SubtitleCaption;
    this.setLength();
  }
  getSubtitleCaption() {
    return this.SubtitleCaption;
  }

  /**
   * 設定timecode
   * @param {*} type  In or Out
   * @param {*} qvalue  時間
   */
  setInOut(type, qvalue, lastTimeString) {
    let value = qvalue;
    if (qvalue === null || qvalue === undefined) {
      value = '';
    }

    const videoFps = TimeUtils.getFPS();

    let newTimeSeting = '';
    let newTimecode = '';
    let newSecond = 0.0;

    if (
      `${value}`.includes(':') === true &&
      `${value}`.includes('.') === true
    ) {
      if (lastTimeString) {
        // 如果相同 跳出不處理
        if (StringUtils.checkStringNotDifferent(lastTimeString, value)) {
          return;
        }
      }

      /**
       * 用戶傳入 Timecode, 直接使用
       */
      // 取出秒數
      const secondValue = TimeUtils.stringConvertToSeconds(
        value,
        parseFloat(videoFps)
      );

      if (DataObj.projectSubType === 1) {
        // console.log('用戶傳入 Timecode, 直接使用 ');
        // 直接用 Timecode
        newTimeSeting = StringUtils.checkTimeString(value);
      } else {
        // console.log('用戶傳入 Timecode, 秒數換算');
        // 秒數換算
        newTimeSeting = StringUtils.checkTimeString(value);
      }

      // 毫秒
      newTimecode = TimeUtils.get_Export_TimecodeFromSeconds(
        secondValue,
        parseFloat(videoFps)
      );
      newSecond = parseFloat(secondValue.toFixed(3));
    } else {
      /**
       * 用戶傳入 秒數 需要轉換
       */

      if (value === '') {
        //空
        newTimeSeting = '';
        newTimecode = '';
        newSecond = 0.0;
      } else {
        //傳入秒數
        newTimeSeting = TimeUtils.convertSecondToTimeString(
          value,
          parseFloat(videoFps)
        );
        newTimecode = TimeUtils.get_Export_TimecodeFromSeconds(
          value,
          parseFloat(videoFps)
        );
        newSecond = value;
      }
    }

    //秒數
    if (type === 'In') {
      this.In = newTimeSeting;
      this.InTimecode = newTimecode;
      this.start = newSecond;
    } else {
      this.Out = newTimeSeting;
      this.OutTimecode = newTimecode;
      this.end = newSecond;
    }
    //更新字串長度

    this.setDuration();
  }

  //取得耗時
  setDuration() {
    // CPS: NaN
    // Duration: "2.50"
    // DurationTitle: "2.50\n(NaN)"
    // In: "00:00:04.15"
    // InTimecode: "00:00:04,625"
    // Length: "11\n5"
    // Memo: ""
    // Out: "00:00:07.03"
    // OutTimecode: "00:00:07,125"
    // Position: ""
    // ShotChange: ""
    // Source: ""
    // SubtitleCaption: "You're fina\nyheeZ"
    // end: 7.125
    // start: 4.625
    if (this['start'] === undefined || this['end'] === undefined) {
      return;
    }

    if (this['In'] === '' || this['Out'] === '') {
      this.Duration = '';
      this.DurationTitle = '';
    } else {
      const distance = parseFloat(
        parseFloat(this['end']) - parseFloat(this['start'])
      );

      if (distance === 0) {
        this.Duration = '0.00';
        this.DurationTitle = '0.00\n(0)';
      } else {
        this.Duration = parseFloat(distance.toFixed(2));
      }
    }
  }

  setLength() {
    this.Length = StringUtils.getStringLength_all(this.SubtitleCaption);
    this.LengthTitle = StringUtils.getStringLength_all(this.SubtitleCaption);
  }

  setCPSTitle() {
    if (this['In'] === '' || this['Out'] === '') {
      this.Duration = '';
      this.DurationTitle = '';
      this.CPS = 0;
    } else {
      const distance = parseFloat(
        parseFloat(this['end']) - parseFloat(this['start'])
      );

      if (distance === 0) {
        this.Duration = '0.00';
        this.DurationTitle = '0.00\n(0)';
        this.CPS = 0;
      } else {
        this.Duration = parseFloat(distance.toFixed(2));

        let totalLength = 0;
        let mutilLine = false;

        if (`${this['Length']}`.includes('\n') === true) {
          //多行

          const lengthArray = this['Length'].split('\n');
          if (lengthArray.length > 1) {
            mutilLine = true;
          }
        }

        if (mutilLine === true) {
          //多行
          const lengthArray = this['Length'].split('\n');

          lengthArray.map((value) => {
            totalLength += parseFloat(value);
          });
        } else {
          //單行
          if (this['Length'] === '') {
          } else {
            totalLength = parseFloat(this['Length']);
          }
        }

        if (totalLength === 0) {
          this.CPS = 0;
        } else {
          this.CPS = parseFloat(
            (totalLength / parseFloat(this['Duration'])).toFixed(1)
          );
        }

        //this.DurationTitle = totalLength;
        this.DurationTitle = distance.toFixed(2) + '\n' + `(${this.CPS})`;
      }
    }
  }

  copySource() {
    this.Source = this.SubtitleCaption;
  }

  //取得拖拉應該有的寬度
  getDragEleWidth() {
    if (this.In === '' || this.Out === '') {
      return 0;
    } else {
      //console.log(`拖拉物件 ${(parseFloat(this.end) - parseFloat(this.start)).toFixed('2') } `);

      //return ((TimeUtils.timeString_convertTo_frame(this.Out,TimeUtils.getFPS()) - TimeUtils.timeString_convertTo_frame(this.In,TimeUtils.getFPS()))) * 2.76;
      //寬度以秒數為主 1秒 40px

      const dragEleWidthValue =
        (parseFloat(this.end) - parseFloat(this.start)).toFixed('3') * 40;

      //console.log(`拖拉物件 ${dragEleWidthValue}`);

      return dragEleWidthValue;
    }
  }

  //取得拖拉應該有的左邊位置
  getDragEleLeft() {
    if (this.In === '' || this.Out === '') {
      return 0;
    } else {
      //扣掉零時寬度
      //return (this.start * TimeUtils.getFPS() * 2.76) + 300 - ZeroTimeUtils.getZerotimeWidth() ;
      //改成以秒為單位 1秒 40px

      const zerotimeWidth = ZeroTimeUtils.getZerotimeWidth();

      return parseFloat(this.start) * 40 + 0 - zerotimeWidth;
    }
  }

  /**
   * 依照送來的 ShotChangeObj 做處理
   * @param {*} data
   * @param {*} ShotChangeObj
   * @param {*} _WaveformView 
   */
  runShotChangeObjCheck(data, ShotChangeObj, _WaveformView) {
    if (this.isIgnoreShotchange === true) {
      // 忽略不修改
    } else {
      if (ShotChangeObj.type === 'In') {
        // 修改 In
        this.setInOut('In', ShotChangeObj.errorShotChangeTitle[0]);
        this.setIsInShotChangeActive(true);

        
      } else {
        // 修改 Out
        this.setInOut('Out', ShotChangeObj.errorShotChangeTitle[0]);
        this.setIsOutShotChangeActive(true);
      }

      //調整輸出字樣 因為有調整過
      this.setShotChange('');

      // 更新
      _WaveformView.DataObjArray.updateDataObj_by_index(
        ShotChangeObj.rowIndex,
        this
      );
    }
  }

  static convertTimeCodeToSeconds(timeString, framerate) {
    var timeArray = timeString.split(':');
    var hours = timeArray[0] * 60 * 60;
    var minutes = timeArray[1] * 60;
    var seconds = timeArray[2];
    var frames = timeArray[3] * (1 / framerate);
    var str =
      'h:' + hours + '\nm:' + minutes + '\ns:' + seconds + '\f:' + frames;

    var totalTime = hours + minutes + seconds + frames;

    //alert(timeString + " = " + totalTime)
    return totalTime;
  }

  static convertTimeToFrames(timeString, framerate) {
    var secs = DataObj.convertTimeCodeToSeconds(timeString, framerate);
    return secs * framerate;
  }

  /**
   * 取出兩個 DataObj 之間的距離
   * @param {*} lastObj 上一個 DataObj
   * @param {*} currentTC 自身 DataObj
   * @returns 
   */
  static getDistance( lastObj,currentTC) {
    const  _Outf = TimeUtils.timeString_convertTo_frame(lastObj.Out);
    const _InF = TimeUtils.timeString_convertTo_frame(currentTC.In);

    return _InF - _Outf;
  } 

}

export default DataObj;



// WEBPACK FOOTER //
// ./src/class/DataObj.js